import type { Resource } from '@frameio/graphql-client/generated';
import { useGetResourceRolesForInvitesQuery } from '@frameio/graphql-client/generated';
import { intl } from '@frameio/i18n';
import { useActiveAccountId } from '@frameio/shared/contexts';
import { toSupportedLocaleOrDefault } from '@frameio/shared/utils/toSupportedLocale';

type Args = {
  resourceId: Resource['id'];
  fetchData?: boolean;
};

export const useGetRolesForResource = ({
  resourceId,
  fetchData = false,
}: Args) => {
  const locale = toSupportedLocaleOrDefault(intl().locale);
  const accountId = useActiveAccountId();

  const { data } = useGetResourceRolesForInvitesQuery({
    variables: { accountId: accountId ?? '', resourceId, locale },
    skip: !resourceId || !fetchData || !accountId,
  });

  return data?.account?.resource?.roles.filter((role) => role.isAssignable);
};
